import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CalendarAllDayHeader, combineHandlers } from 'owa-calendar-surface-core';
import {
    useAllDayWellHooks,
    DroppableType,
    CalendarSurfaceTransformProps,
    CalendarSurfaceStore,
} from 'owa-calendar-surface-dategrid';
import { useSurfaceDroppableHooks } from 'owa-calendar-surface-dategrid-common-dnd';

export interface DayGridAllDayHeaderAdditionalProps {
    viewState: CalendarSurfaceStore;
    calendarFolderId?: string;
    calendarConfig: CalendarSurfaceTransformProps;
}

export default observer(function DayGridAllDayHeaderComponent({
    className,
    children,
    handlers,
    additionalProps,
}: {
    className?: string;
    children?: React.ReactNode;
    handlers?: React.DOMAttributes<HTMLElement>;
    additionalProps: DayGridAllDayHeaderAdditionalProps;
}) {
    const { viewState, calendarFolderId, calendarConfig } = additionalProps;

    const surfaceDroppableBehaviorHook = useSurfaceDroppableHooks({
        store: viewState,
        columnProvider: calendarConfig.columnProvider,
        dragDropConfig: calendarConfig.dragDropConfig,
        droppableType: DroppableType.AllDay,
        calendarFolderId: calendarFolderId,
    });

    const allDayWellHooks = useAllDayWellHooks({
        store: viewState,
        config: calendarConfig,
        calendarFolderId: calendarFolderId,
    });

    const handlersToAttach = combineHandlers(
        surfaceDroppableBehaviorHook.handlers,
        allDayWellHooks.handlers,
        handlers
    );

    return (
        <CalendarAllDayHeader className={className} handlers={handlersToAttach}>
            {children}
        </CalendarAllDayHeader>
    );
});
